import { EmploymentStatusDto } from '@app/member-response-portal/model/employmentStatusDto';
import { Helper } from '@rawlings/core';
import { OtherBenefitsDto } from '@app/member-response-portal/model/otherBenefitsDto';
import { OtherHealthInsuranceDto } from './otherHealthInsuranceDto';
import { SocialSecurityBenefitsDto } from './socialSecurityBenefitsDto';

export class SurveySummaryDto {
    //#region Public Variables
    public OtherHealthInsurance: OtherHealthInsuranceDto;
    public SocialSecurityBenefits: SocialSecurityBenefitsDto;
    public EmploymentStatus: EmploymentStatusDto;
    public OtherBenefits: OtherBenefitsDto;
    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(item?: any) {
        Helper.Construct(item, this);
    }
    //#endregion Constructor

    //#region Public Methods
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
